module.exports = __webpack_public_path__ + "static/media/interreg-vn-horizontal.12c9871a.jpg";